import { HomeSliceType, TwitterCarouselSlice } from '../../../../types/slice';

const twitterCarouselSlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): TwitterCarouselSlice => {
  if (data.primary?.enabled !== 'oui' || !data.primary?.list) {
    return undefined;
  }

  return {
    type: HomeSliceType.TWITTER_CAROUSEL,
    list: data.primary.list,
  };
};

export default twitterCarouselSlice;
